import PrivacyPolicy from "./Privacy-Policy";

function Getit(){
    return(
        <div>
            This shows due to you are in /getit index
        </div>
    )
}

export default Getit;